import Products from 'merchandise-lib/constants/Product';
export const HUB_TO_HSOC_PRODUCT_MAP = {
  [Products.CRM_SUITE_STARTER_BUNDLE]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.MARKETING_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.MARKETING_HUB_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.MARKETING_HUB_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.CMS_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.CMS_HUB_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.CMS_HUB_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.OPERATIONS_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.OPERATIONS_HUB_PROFESSIONAL]: Products.CORE_SEATS_PROFESSIONAL_HSOC,
  [Products.OPERATIONS_HUB_ENTERPRISE]: Products.CORE_SEATS_ENTERPRISE_HSOC,
  [Products.SALES_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.SALES_HUB_PROFESSIONAL]: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.SALES_HUB_ENTERPRISE]: Products.FRONT_OFFICE_SEATS_ENTERPRISE,
  [Products.SERVICE_HUB_STARTER]: Products.CORE_SEATS_STARTER_HSOC,
  [Products.SERVICE_HUB_PROFESSIONAL]: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.SERVICE_HUB_ENTERPRISE]: Products.FRONT_OFFICE_SEATS_ENTERPRISE,
  [Products.COMMERCE_HUB_PROFESSIONAL]: Products.FRONT_OFFICE_SEATS_PROFESSIONAL,
  [Products.COMMERCE_HUB_ENTERPRISE]: Products.FRONT_OFFICE_SEATS_ENTERPRISE
};
export const mapProductForHubSpotOnCredits = upgradeConfig => {
  const originalApiName = upgradeConfig.bestFitApiNameForPurchase;
  if (!originalApiName) {
    return upgradeConfig;
  }
  const mappedApiName = HUB_TO_HSOC_PRODUCT_MAP[originalApiName];
  if (!mappedApiName) {
    return upgradeConfig;
  }
  return Object.assign({}, upgradeConfig, {
    bestFitApiNameForPurchase: mappedApiName
  });
};